import { render, staticRenderFns } from "./WalletBalanceResume.vue?vue&type=template&id=b99057f4&scoped=true&"
import script from "./WalletBalanceResume.vue?vue&type=script&lang=js&"
export * from "./WalletBalanceResume.vue?vue&type=script&lang=js&"
import style0 from "./WalletBalanceResume.vue?vue&type=style&index=0&id=b99057f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99057f4",
  null
  
)

export default component.exports